import {AFD} from 'devegram-javascript-util'

const baseUrl = '/xapi/Individual/ProfileModule';
const moduleAjaxService = 'AMS'

const api = {
    namespaced: true,
    state: {
        availableModules: [],
        assignedModules: [],
        loading: false
    },
    actions: {
        async getAvailableModules(context) {
            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl + '/getAvailableModules',
                data: null
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    // Handle new response format: {success: true, modules: [...], count: 52}
                    const modules = r.data.modules || r.data || [];
                    context.commit('SET_AVAILABLE_MODULES', modules);
                    resolve(modules);
                }).catch(e => {
                    // Handle 400 status but still process if data exists (same as getByProfile)
                    if (e.response && e.response.data && e.response.data.modules) {
                        const modules = e.response.data.modules || [];
                        context.commit('SET_AVAILABLE_MODULES', modules);
                        resolve(modules);
                    } else {
                        reject(e);
                    }
                })
            })
        },

        async getByProfile(context, params) {
            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl + '/getByProfile/' + params.profile_id,
                data: null
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    // Handle new response format: {success: true, profile_id: "9", modules: [...], count: 9}
                    const modules = r.data.modules || r.data || [];
                    context.commit('SET_ASSIGNED_MODULES', modules);
                    resolve(modules);
                }).catch(e => {
                    // Handle 400 status but still process if data exists
                    if (e.response && e.response.data && e.response.data.modules) {
                        const modules = e.response.data.modules || [];
                        context.commit('SET_ASSIGNED_MODULES', modules);
                        resolve(modules);
                    } else {
                        reject(e);
                    }
                })
            })
        },

        async assignToProfile(context, params) {
            let api = {
                verb: 'post',
                service: moduleAjaxService,
                url: baseUrl + '/assignToProfile',
                data: AFD({
                    profile_id: params.profile_id,
                    modules: params.modules
                })
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                })
            })
        },

        async removeFromProfile(context, params) {
            let api = {
                verb: 'post',
                service: moduleAjaxService,
                url: baseUrl + '/removeFromProfile',
                data: AFD({
                    profile_id: params.profile_id,
                    modules: params.modules
                })
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                })
            })
        }
    },
    mutations: {
        SET_AVAILABLE_MODULES(state, modules) {
            state.availableModules = modules;
        },
        SET_ASSIGNED_MODULES(state, modules) {
            state.assignedModules = modules;
        },
        SET_LOADING(state, loading) {
            state.loading = loading;
        }
    }
}

export default api